import React from 'react'
import { SectionHeader, Props } from 'component-library/section-header/SectionHeader/SectionHeader'
import { createRegisterableComponent } from 'common/routing/page-definition'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SectionHeaderRouteProps extends Props {}

export const SectionHeaderRegistration = createRegisterableComponent(
    'section-header',
    (props: SectionHeaderRouteProps) => <SectionHeader {...props} />
)
